import type { Intent } from '@wand/shared/text/intent.js';

/**
 * "How did you improve yourself?" is the same question as "what have you improved about
 * yourself?" and as "how did you get better?", and an estate where one of them answers and
 * the others do not is an estate that looks fragile in the room.
 *
 * So one intent, carried by all three story agents, each answering for ITSELF: the born
 * sentinel lists what it changed and the one thing it cannot; the Wand-native analyst says
 * it improved once and a person did it; the external A2A agent says it has not improved and
 * has nothing to improve from. Asking the same question three times and getting three
 * different, honest answers is the whole ladder in one exchange.
 *
 * THE VETO LIST IS THE LOAD-BEARING HALF. "what did you learn from FRD-3309?" belongs to the
 * Claims Fraud Analyst and must stay silent everywhere else, and it carries both a verb
 * (`learn`) and a subject (`you`). `from` is what keeps it silent — a question about what an
 * agent learned FROM something is a question about that thing, not about the agent. The same
 * goes for a process, a claim or a threshold: those are objects, and this intent is only ever
 * about the speaker.
 */
export const SELF_ACCOUNT: Intent = {
  all: [
    [
      'improve',
      'improved',
      'improves',
      'improving',
      'improvement',
      'improvements',
      'better',
      'evolve',
      'evolved',
      'evolves',
      'evolving',
      'learn',
      'learned',
      'learnt',
      'learning',
      'progressed',
      'grown',
      'sharper',
      'change',
      'changed',
    ],
    ['yourself', 'your own', 'itself', 'its own', 'you', 'your'],
  ],
  none: [
    'from',
    'about the',
    'process',
    'processes',
    'workflow',
    'workflows',
    'model',
    'claim',
    'claims',
    'case',
    'cases',
    'threshold',
    'desk',
    'we',
    'us',
    'they',
    'them',
  ],
};
